import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    collapseTitle: {
      type: String,
      required: true
    },
    collapseContent: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      pointsVisible: false
    };
  },
  methods: {
    showPoints: function showPoints() {
      this.pointsVisible = !this.pointsVisible;
    }
  }
};